import { render, staticRenderFns } from "./StaffAdmin.vue?vue&type=template&id=bb1081b8&scoped=true&"
import script from "./StaffAdmin.vue?vue&type=script&lang=js&"
export * from "./StaffAdmin.vue?vue&type=script&lang=js&"
import style0 from "./StaffAdmin.vue?vue&type=style&index=0&id=bb1081b8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb1081b8",
  null
  
)

export default component.exports